import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '../components/App'
import { ErrorBoundary } from '../components/ErrorBoundary'
import '../styles/application.css'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root')
  if (container) {
    const root = createRoot(container)
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </React.StrictMode>
    )
  }
})
